module.exports = __webpack_public_path__ + "static/media/MX.ac4aa219.svg";